import { render, staticRenderFns } from "./CoffInputColor.vue?vue&type=template&id=6ce0c384&scoped=true"
import script from "./CoffInputColor.vue?vue&type=script&lang=js"
export * from "./CoffInputColor.vue?vue&type=script&lang=js"
import style0 from "./CoffInputColor.vue?vue&type=style&index=0&id=6ce0c384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce0c384",
  null
  
)

export default component.exports